const initialState = {
  newAdminCategory: false,
  name: null,
  color: '',
  categoryCalenderId: '',
};

export default initialState;
